export default __webpack_public_path__ + "static/media/Icons_Power Icon.0e81bc7e.svg";